import React from "react"

interface Props {
  className?: string
}

const StoreIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.21997 10.89V20.89"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.78 10.89V20.89"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2221 20.889V16.445C14.2221 15.218 13.2271 14.223 12.0001 14.223C10.7731 14.223 9.77808 15.218 9.77808 16.445V20.889"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 20.89H22"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.30107 10.889C2.60307 10.877 1.49607 9.196 2.23207 7.747L3.94707 4.37C4.33807 3.6 5.16007 3.111 6.06207 3.111H17.9381C18.8401 3.111 19.6621 3.6 20.0531 4.37L21.7691 7.747C22.5051 9.196 21.3981 10.877 19.7001 10.889C18.2831 10.889 17.1341 9.921 17.1341 8.726V8.678C17.1341 9.899 15.9851 10.889 14.5681 10.889C13.1511 10.889 12.0021 9.899 12.0021 8.678C12.0021 9.899 10.8531 10.889 9.43607 10.889C8.01907 10.889 6.87007 9.899 6.87007 8.678V8.726C6.86707 9.921 5.71807 10.889 4.30107 10.889Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default StoreIcon
